import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { MessageCircle, Users } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function Chats() {
  const { t } = useTranslation();
  const [chats, setChats] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/chats").then((r) => setChats(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 pt-6 pb-32">
      <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight mb-5">{t("chats.title")}</h1>
      {loading ? (
        <div className="space-y-3">{[...Array(4)].map((_, i) => <div key={i} className="card-nb h-20 animate-pulse bg-[#F4F1EA]"/>)}</div>
      ) : chats.length === 0 ? (
        <div className="card-nb p-10 text-center bg-[#FFE4E1]" data-testid="chats-empty">
          <MessageCircle className="w-12 h-12 mx-auto mb-3"/>
          <h3 className="font-display font-black text-2xl mb-1">{t("chats.noChats")}</h3>
          <p className="text-[#4A4A4A]">{t("chats.noChatsBody")}</p>
        </div>
      ) : (
        <div className="space-y-3">
          {chats.map((c) => (
            <Link key={c.id} to={`/chats/${c.id}`} data-testid={`chat-${c.id}`} className="card-nb p-4 flex items-center gap-3 bg-white hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-nb-sm transition-all">
              <div className="w-12 h-12 rounded-full bg-[#FFF0D4] border-2 border-[#121212] flex items-center justify-center shrink-0">
                <Users className="w-5 h-5" strokeWidth={2.5}/>
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-display font-bold truncate">{c.title || t("chats.group")}</div>
                <div className="text-sm text-[#4A4A4A] truncate">{c.last_message || t("chats.sayHi")}</div>
              </div>
              <span className="tag-nb bg-[#EBE4FF]">{c.participant_ids.length}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
